import { FunctionComponent, PropsWithChildren } from 'react';

type DetailsTableProps = PropsWithChildren;

export const DetailsTable: FunctionComponent<DetailsTableProps> = ({ children }) => (
    <table className="table table-row-first-border-none table-row-last-border-none table-layout-fixed table-column-overflow-hidden">
        <tbody>{children}</tbody>
    </table>
);
